import axios from 'axios'

export const getAddressesV2 = (kvdm = false) => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/v3/address', { params: kvdm ? { kvdm: true } : {} })
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const addDeliveryAddress = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/address', address)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const deleteDeliveryAddress = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete('/api/v3/address/' + id)
      .then(() => resolve())
      .catch((error) => {
        reject()
      })
  })
}

export const editDeliveryAddress = (address) => {
  return new Promise((resolve, reject) => {
    axios
      .patch('/api/v3/address/' + address.id, address)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const saveProject = (customer, project) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/v3/address/${customer}/project`, project)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}
export const saveReference = (customer, reference) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/v3/address/${customer}/reference`, reference)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const deleteProject = (project) => {
  return new Promise((resolve, reject) => {
    axios

      .delete(`/api/v3/address/project/${project.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const deleteReference = (reference) => {
  return new Promise((resolve, reject) => {
    axios

      .delete(`/api/v3/address/reference/${reference.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}
